import { PanelAttribute, getType } from "@serenity-is/corelib";

// make dialogs open as modals by default as before
let typeInfo = (getType('Serenity.EntityDialog') as any).typeInfo;
typeInfo.customAttributes = typeInfo.customAttributes.filter((x: any) => !(x instanceof PanelAttribute))
